import React from 'react';
import SiteContentContext from '../../content/SiteContentContext';
import { getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

const fallbackLogos = [
    { image: require('./../../images/client-logo/logo1.png') },
    { image: require('./../../images/client-logo/logo2.png') },
    { image: require('./../../images/client-logo/logo3.png') },
    { image: require('./../../images/client-logo/logo4.png') },
    { image: require('./../../images/client-logo/logo5.png') },
    { image: require('./../../images/client-logo/logo6.png') },
    { image: require('./../../images/client-logo/logo7.png') },
    { image: require('./../../images/client-logo/logo8.png') }
];

var bgimg1 = require('./../../images/background/bg-12.jpg');

class ClientsLogo1 extends React.Component {
    static contextType = SiteContentContext;

    render() {
        const content = this.context?.content || {};
        const configured = getByPath(content, 'media.pages.clientLogos', []);
        const configuredLogos = Array.isArray(configured)
            ? configured.filter((item) => typeof item === 'string' ? item.trim() : item?.imageUrl?.trim())
            : [];

        const logos = configuredLogos.length
            ? configuredLogos.map((item, index) => ({
                image: resolveMediaSrc(typeof item === 'string' ? item : item.imageUrl, fallbackLogos[index % fallbackLogos.length].image)
            }))
            : fallbackLogos;

        return (
            <>
                <div className="section-full mobile-page-padding bg-gray p-t40 p-b10 bg-repeat" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container">
                        <div className="section-content">
                            <div className="client-grid m-b40">
                                <div className="row justify-content-center">
                                    {logos.map((item, index) => (
                                        <div className="col-lg-3 col-md-4 col-sm-6 col-6 m-b30" key={index}>
                                            <div className="client-logo-pic" aria-label={`Müşteri logosu ${index + 1}`}>
                                                <img src={item.image} alt="Müşteri logosu" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default ClientsLogo1;